import React from "react";

export default function HomeControlsPage() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Home Controls</h2>
      <p>This is where smart home controls will go.</p>
    </div>
  );
}
